var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganisation = function SvgOrganisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 21.8V2h10.725v4.538H23V21.8zm1.65-1.65h2.887v-2.887H2.65zm0-4.537h2.887v-2.888H2.65zm0-4.538h2.887V8.188H2.65zm0-4.537h2.887V3.65H2.65zM7.188 20.15h2.887v-2.887H7.188zm0-4.537h2.887v-2.888H7.188zm0-4.538h2.887V8.188H7.188zm0-4.537h2.887V3.65H7.188zm4.537 13.612h9.625V8.188h-9.625v2.887h2.2v1.65h-2.2v2.888h2.2v1.65h-2.2zm5.088-7.425v-1.65h1.65v1.65zm0 4.538v-1.65h1.65v1.65z"
  })));
};
export default SvgOrganisation;